export const DIRECTIONS = Object.freeze({
  ROW: 'row',
  COLUMN: 'column',
})
